export const text = {
  common: {
    mc: '商戶合約',
    ts: '服務條款',
    all: '所有',
  },
  login: {
    welcome: '歡迎進入 \n Atome 商店中心',
    username: '使用者名稱',
    password: '密碼',
    forget: '忘記密碼?',
    login: '登入',
    incorrect: `使用者名稱或密碼不正確。若忘記密碼，請點選下方"忘記密碼"並重新設定。`,
    placeholder: '請輸入使用者名稱/email',
    placeholder2: '請輸入密碼',
  },
  profile: {
    setting: '帳戶設定',
    profile: '公司資料',
    company: '公司',
    address: '地址',
    phone: '電話',
    email: '電子郵件',
    createTime: '創建時間',
    subscription: '訂閱',
    subscribe: '訂閱',
    editSubscription: '編輯訂閱',
    dailyPayoutReport: '每日付款報告',
    dailyTransReport: '每日交易報表',
    changePwd: '更改密碼',
    logout: '登出',
    username: '用戶名稱',
    outlet: '門市',
    password: '密碼',
    language: '語言',
  },
  roleList: {
    roleMana: '角色管理',
    addRole: '添加角色',
    roleName: '角色名稱',
    time: '建立時間',
    action: '動作',
    confirmDel: '確認刪除角色 ',
    delete: '刪除',
    deleteTip: '你確定要刪除角色{{roleName}}嗎？此操作不能撤消。',
    desc: '描述',
    roleDetail: '角色詳細信息',
    cancel: '取消',
    edit: '編輯',
    success: '刪除成功',
    failed: '刪除角色失敗，請稍後再試',
  },
  role: {
    roleName: '角色名稱',
    permissions: '權限',
    desc: '描述',
    confirm: '確認',
    cancel: '取消',
    addRole: '添加角色',
    editRole: '編輯角色',
    required1: `請填寫使用者名稱`,
    required2: `請選擇管理權限`,
    select: '請選擇',
    success: `你已成功編輯此角色`,
    success2: `你已成功創建新角色`,
  },
  userList: {
    userMana: '用戶管理',
    addUser: '添加用戶',
    role: '角色',
    userName: '用戶名稱',
    search: '搜尋',
    email: '電子郵件',
    time: '建立時間',
    action: '動作',
    edit: '編輯',
    del: '刪除',
    userDetail: '用戶詳細資料',
    delTip: '你確定要刪除用戶{{userName}}嗎？此操作不能撤消。',
    delTitle: '確認刪除用戶 {{userName}}',
    delSuccess: `你已成功刪除用戶{{userName}}。`,
  },
  user: {
    editUser: '編輯用戶',
    addUser: '增加用戶',
    userName: '用戶名稱',
    email: '電子郵件',
    time: '建立時間',
    role: '角色',
    outlet: '門市',
    password: '密碼',
    reset: '重置密碼',
    good: '高強度的密碼是混合使用大寫字母、小寫字母、數字和至少8個字符的長度。',
    confirm: '確認',
    cancel: '取消',
    required1: `「用戶名稱」是必須的`,
    required2: `「角色」是必須的`,
    required3: `「門市」是必須的`,
    required4: `「密碼」是必須的`,
    select: '請選擇',
    weak: '你的密碼太弱，請確保你滿足密碼強度要求。',
    success: `你已經成功創建了新的用戶帳戶。`,
    poor: '弱',
    medium: '中等',
    good2: '強',
    excellent: '很強',
    tip: `用戶名稱允許的字符包括：A-Z，a-z，0-9，'。'，'_'，'@'。`,
    emailTip: '請確保此電郵地址正確無誤-當你忘記密碼時，我們會發送電子郵件至此電郵地址。',
    emailErrMsg: '請輸入有效的電郵地址',
  },
  analytics: {
    all: '所有',
    analytics: '分析工具',
    period: '期間',
    frequency: '頻率',
    weekly: '每週',
    monthly: '每月',
    vs: '與此期間比較',
    outlet: '門市',
    allTime: '整段時間',
    last4Weeks: '過去4週',
    last3Months: '過去3個月',
    weeklyDesc: '週別: 由星期一開始',
    monthlyDesc: '月別: 由1號開始',
  },
  charts: {
    order: '訂單',
    total: '總交易金額（包括退款訂單）:',
    totalCount: '訂單總數（包括退款訂單）:',
    ave: '平均交易金額:',
    data: '人口統計數據是按訂單收集的。',
    cd: '客戶人口統計',
    ot: '網絡流量',
    others: '其他',
    age: '年齡組別',
    majority: '主要',
    type: '卡的種類',
    cr: '信用卡',
    dc: '扣帳卡',
    pc: '預付卡',
    gender: '性別',
    female: '女性',
    male: '男性',
    current: '當前',
    previous: '早前',
    exposure: '曝光率',
    leads: '轉介',
    weekly: '每週',
    hover1: '此圖顯示了你的商店在Atome app中獲顧客看到的次數。',
    hover2: '此圖顯示了顧客從Atome app導向到你網站的次數。',
    hover1Dec: '此圖顯示了從2020/12/01起你的商店在Atome app中獲顧客看到的次數。',
    hover2Dec: '此圖顯示了從2020/12/01起顧客從Atome app導向到你網站的次數。',
    count: '贊助優惠券的使用次數',
    amount: '贊助優惠券的金額',
  },
  password: {
    old: '舊密碼',
    new: '新密碼',
    retype: '重新輸入密碼',
    change: '更改密碼',
    tip: '高強度密碼需混合使用大寫字母、小寫字母、數字和至少8個字符的長度。',
    notMatch: '輸入的密碼不對應。',
    tooWeak: '你的密碼太弱，請確保你滿足密碼強度要求。',
    notCorrect: '您輸入的密碼不正確。',
    success: '成功重置密碼。',
    poor: '弱',
    medium: '中等',
    good2: '強',
    excellent: '很強',
    error: '網絡錯誤',
    wrong: '很抱歉，您的使用者名稱或email錯誤，請重新輸入。',
    receive: '帳號註冊完成後，您將會收到重設密碼指示的郵件。',
    ops: `喔不好了,出現錯誤。請重新嘗試或是聯繫我們 {{contactEmail}}`,
    forget: '忘記密碼?',
    noWorry: '別擔心!',
    userName: '使用者名稱',
    email: 'Email',
    tip2: '如果您已有註冊帳號，請在下方輸入，我們會發送密碼重設流程到您的email。',
    invalid: '無效的email格式',
    your: '您的使用者名稱',
    send: '發送',
    reset: '密碼已重設，請重新登錄。',
    welcome: '歡迎',
    needToChange: '由於這是你的首次登錄，因此需要同意商戶合約並更改密碼。',
  },
  subscription: {
    subscriptionPayout: '通過電子郵件訂閱支付報告',
    subscriptionTransaction: '通過電子郵件訂閱交易報告',
    titlePayout: '每天早上8時，我們將向你發送一封包含昨天結算報告的電子郵件。',
    titleTransaction: '每天早上8時，我們將向你發送一封包含昨天交易報告的電子郵件。',
    displayBy: '記錄顯示根據',
    recipient: '接收者',
    cc: '抄送',
    bcc: '密件抄送',
    unsubscribe: '取消訂閱',
    confirm: '確認',
    item: '結算項目',
    trans: '結算交易',
    error1: '收件人電子郵件格式無效，請檢查並再次輸入',
    error2: '抄送的電子郵件格式無效，請檢查並再次輸入',
    error3: '密件抄送的電子郵件格式無效，請檢查並再次輸入',
    successPayout: `你已經成功訂閱了結算報告。`,
    successTransaction: `你已經成功訂閱了交易報告。`,
    success2Payout: `你已成功取消訂閱結算報告。`,
    success2Transaction: `你已成功取消訂閱交易報告。`,
  },
  transaction: {
    detail: '交易明細',
    notFound: '找不到記錄',
    refund: '退款',
    maxAmount: '可退款的最高金額',
    refundAmount: '退款金額',
    confirm: '確認',
    close: '關閉',
    errMsg1: '無法繼續你的退款請求。請稍後再試。',
    transId: '交易編號',
    date: '交易日期和時間',
    status: '狀態',
    transAmount: '交易金額',
    confirmed: '已確認',
    settled: '已結算',
    refundStr: '{{amount}} 退款已於{{timeStr}}處理',
    timeFormat: '{{date}}的{{time}}',
    refundId: '退款交易編號',
    range: '可退款金額為',
    to: '至',
    inclusive: '含',
    amountBreak: '金額明細',
    amountFee: 'Atome 費用金額：',
    amountFeeVat: 'Atome Fees VAT:',
    amountFeeWht: 'Atome Fees WHT:',
    history: '歷史',
    wrongParams: '由於參數錯誤，Atome撤銷了此交易。如有任何疑問，請聯繫',
    reversed: '此交易已撤消。',
    id: 'Transaction ID',
    transactionId: '交易編號',
    outlet: '門市',
    transactionDate: '交易日期和時間',
    transactionAmount: '交易金額',
    amountReceivable: '應收款項',
    transactionType: '交易類型',
    atomeId: 'Atome訂單編號',
    eId: '電子商務平台訂單編號',
    voucherAmount: '贊助優惠券的金額',
    adjusted: '已調整',
    REFUND: '退款',
    MERCHANDISE: '訂單',
    ADJUSTMENT: '調整',
    reversed2: '此交易已取消，請從TXN退款',
    transOutlet: '交易門市',
    customerName: '顧客姓名',
    phone: '電話號碼',
    reversed3: 'Atome取消了此項交易。你可以透過',
    reversed4: '找到正確的詳細信息',
    transactions: '交易',
    error: '抱歉，網絡未能連接，請稍後再試。',
    name: '顧客姓名',
    createPayment: 'Create payment link',
    transactionStatus: '交易狀態',
    date2: '日期',
    selectOutlet: '選擇門市',
    mobile: '手提電話',
    orderId: 'Atome訂單編號',
    eOrderId: '電子商務平台訂單編號',
    search: '搜尋',
    export: '導出',
    tip: '請確保你所選擇的開始和結束日期在一個月內。',
    ALL: '所有',
    UNSETTLED: '已確認',
    SETTLED: '已結算',
    today: '今天',
    last7: '過去7天',
    last30: '過去30天',
    all: '所有',
  },
  welcome: {
    change: '更改密碼',
    welcome: '歡迎',
    needToAgree: '由於這是你首次登錄，因此你需要同意商戶合約。',
    needToAddEmail: '由於這是您的首次登錄，因此需要你的輸入電子郵件地址並同意商戶合約。',
    needToChange: '由於這是你的首次登錄，因此需要同意商戶合約並更改密碼。',
    agree: '我同意',
    contract: '商戶合約',
    ok: 'OK',
    emailExtra: '請確保此電郵地址正確無誤-當你忘記密碼時，我們會發送電子郵件至此電郵地址。',
    emailErrMsg: '請輸入有效的電郵地址',
    emailPlaceholder: '輸入你的電郵地址',
  },
  dashboard: {
    dashboard: '儀表板',
    overview: '總覽',
    totalTrans: '交易總數',
    totalAmount: '總交易金額',
    totalRefundTrans: '退款交易總數',
    totalRefundAmount: '退款總額',
    today: '今天',
    last7: '過去七天',
    last30: '過去30天',
    all: '所有',
    transaction: '交易#',
    confirmed: '已確認',
    settled: '已結算',
    moreTrans: '更多交易',
    activity: '活動',
  },
  company: {
    payments: '款項',
    payout: '付款',
    dashboard: '儀表板',
    transactions: '交易',
    balance: '結餘',
    ana: '分析工具',
    roleMana: '角色管理',
    userMana: '用戶管理',
    help: '幫助',
    accountMana: '帳戶管理',
  },
  payments: {
    sale: '銷售額',
    atomeFee: 'Atome費用',
    rebate: '回扣',
    voucher: '贊助優惠券',
    all: '所有',
    balance: '結餘',
    outBalance: '未付結餘',
    outlet: '門市',
    total: '總額',
    id: '付款編號',
    detail: '付款明細',
    viewLevel: '查看水平',
    settlementItem: '結算項目',
    settlementItemTip: '每筆交易都細分為不同的結算項目，例如：銷售，Atome費用。',
    settlementTran: '結算交易',
    settlementTranTip: '一次銀行付款中的每筆交易只有一條記錄。',
    tranId: '交易編號',
    tranType: '交易類型',
    tranDate: '交易日期',
    tranAmount: '交易金額',
    amountRe: '應收款項',
    amountPayout: '支付金額',
    error: '抱歉，網絡未能連接，請稍後再試。',
    summary: '概要',
    export: '導出',
    subscription: '訂閱',
    payoutMade: '從Atome支付到你銀行帳戶的款項。',
    date: '付款日期',
    outletName: '門市名稱',
    allSettledCount: '已結算的交易數量',
    allSettledItemCount: '已結算的項目數量',
    saleCount: '銷售額結算項目數量',
    atomeFeeCount: 'Atome費用計算',
    voucherCount: '贊助優惠券數量',
    vatCount: 'Atome Fees VAT Count',
    rebateVatCount: 'Rebate VAT Count',
    whtCount: 'Atome Fees WHT Count',
    rebateWhtCount: 'Rebate WHT Count',
    rebateCount: '回扣數量',
    payoutAmount: '付款金額',
    payoutStatus: '狀態',
    inTransit: '轉帳中',
    paid: '已到帳',
    payout: 'atome銀行付款',
    date2: '日期',
    today: '今天',
    last7: '過去七天',
    last30: '過去30天',
  },
  download: {
    export: '導出',
    close: '關閉',
    ready: `你的導出已預備。如果看不到你所需的文件，`,
    preparing: '準備導出...',
    remaining: '尚餘數秒...',
    again: '你可以嘗試再次下載。',
    wrong: '你的導出出現了一些問題。我們正在調查中，請稍後再試，或與我們的支援團隊聯繫',
  },
  help: {
    help: '幫助',
    dashboard: '儀表板',
    h1: '「交易總數」、「交易總額」、「退款總數」和 「退款總額」是什麼意思？',
    p1: `每個項目將顯示選定的時段內相應的數據。<br/>
交易總數：通過Atome進行的商品交易總數量（僅針對此商家帳戶）<br/>
交易總額：通過Atome進行的商品交易總金額（僅針對此商家帳戶）<br/>
退款總數：退款總數量（僅針對此商家帳戶）<br/>
退款總額：退款總金額（僅針對此商家帳戶）<br/>
*請注意，當前不支持所有門市之間的交易數據同步。`,
    h2: '「活動」表中將顯示什麼？',
    p2: '活動表將顯示通過Atome進行的最新交易（包括已結算的訂單，已確認的訂單和退款訂單）。',
    h3: '我可以在商戶儀表板上跟踪使用Atome優惠券的訂單嗎？',
    p3: '目前尚不可用。',
    transTable: '交易表',
    h4: '「篩選」如何運作？',
    p4: `此功能讓你可以檢查選定時段內的銷售情況。你可以通過選擇不同的訂單狀態和訂單類型來查看結果。另外，你可以通過用戶的電話號碼或Atome訂單編號搜尋訂單。請注意，該表僅顯示選定時段內的數據。`,
    h5: '不同狀態的定義是什麼？',
    p5: `該狀態可以幫助你篩選已結算的訂單和已確認的訂單。<br/>
已確認的訂單：產生交易時，訂單狀態將顯示為「已確認」。<br/>
已結算的訂單：僅在財務團隊成功結算解決時顯示此狀態。`,
    h6: '如何使用「電話號碼」和「訂單編號」在交易儀表中進行搜尋？',
    p6: `電話號碼是用戶註冊時所使用的電話號碼。使用電話號碼進行篩選顯示該用戶在你選擇的時段內完成的所有訂單（包括已結算、已確認和退款）。<br/>
訂單編號應該是Atome系統中的交易編號。可用於搜尋索個別訂單。`,
    h7: '如何將數據導出到試算表？',
    p7: `點擊「導出」以下載你篩選的數據的CSV文件。此文件可以在試算表或任何支持此格式的軟件中打開。`,
    companyInfo: '公司資料',
    h8: '如何更改我的公司資料？',
    p8: `請聯繫並通知Atome客戶管理團隊更改公司資料的原因。確認後，他們將在xx個工作日內協助你進行更改。`,
    h9: '更改公司資料的次數有限制嗎？',
    p9: `不，我們對此沒有任何限制。但請注意，請告知我們你需要進行更改的原因。`,
    account: '帳戶和密碼',
    h10: '我的用戶名稱和初始密碼是什麼？',
    p10: '用戶名稱和初始密碼應包含在發送給你的登陸電子郵件中。如有任何疑問，請與你的客戶經理聯繫。',
    h11: '如果忘記密碼該怎麼辦？',
    p11: `可以通過電子郵件設置新密碼。<br/>
點擊登錄頁面中的「忘記密碼」，然後驗證你的電子郵件。帶有重置連結的電子郵件將在幾分鐘後發送到你的電子郵箱。<br/>
如果你沒有使用任何電子郵件地址，請與你的客戶經理聯繫以重置密碼。`,
    h12: '如何更改/重置密碼？',
    p12: `進入「個人資料」，然後點擊「更改密碼」。新密碼不能與舊密碼相同。<br/>
高強度的密碼是混合使用大寫字母、小寫字母、數字和至少8個字符的長度。`,
    h13: '更改密碼的次數有限制嗎？',
    p13: `不，我們對此沒有任何限制。`,
    h14: 'Can I create multiple passwords for each branch account?',
    p14: `Yes, this is available. For more details, please contact your account manager to finish setting multiple passwords.`,
    refund: '退款',
    h15: '如果我開始退款，是否會退還Atome收取的佣金？佣金是退款之前或是之後退還？',
    p15: '退款後，Atome收取的佣金將退還到你的帳戶中。',
    h16: '我可以從主賬戶開始退款嗎？',
    p16: `是的，你可以從商店經理帳戶或公司管理員帳戶或貴公司創建的具有「退款」權限的任何帳戶中退款。`,
    h17: `如果我是網店商家，那麼在第三方平台上完成的退款是否會與Atome商戶服務中心同步？`,
    p17: `"是的，所有在第三方平台上完成的退款都將同步到Atome商戶服務中心，但可能會有一些數據延遲。<br/>
但是，請注意，在Atome商戶服務中心完成的退款將不會顯示在任何第三方平台上。"`,
    needHelp: '找不到你所需的答案？我們可在此為你提供協助。',
    reach: '請發送電子郵件至',
    reach2: ' 與我們聯繫。',
  },
};
